import { C } from '@/lib/constants';

interface PhotoIconProps {
  size?: number;
  color?: string;
}

export function PhotoIcon({ size = 14, color: c }: PhotoIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className="block">
      <rect x="1" y="2.5" width="14" height="11" rx="2" stroke={c || C.mid} strokeWidth="1.4" fill="none" />
      <circle cx="5.5" cy="6.5" r="1.5" fill={c || C.mid} />
      <path d="M1.5 11l3.5-3.5 2.5 2.5 2-1.5 5 4" stroke={c || C.mid} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
